import React, { Component } from "react";
import WidgetPageRenderer from "../widgets/WidgetPageRenderer";

import LoadingOverlay from "./LoadingOverlay";
export default class Form_field_validations_NEW extends Component {
  render() {
    return <WidgetPageRenderer pageRoute="form_field_validations" />;
  }
}
